import type { Direction } from '../types/label-perf';

export const getTrendDirection = (value: number): Direction => {
  if (value > 0) {
    return 'up';
  }

  if (value < 0) {
    return 'down';
  }

  return 'none';
};

export const calculateTrendPercentage = (
  monthlyRevenue: number,
  monthlyRevenueTrend: number,
  fixed = 1,
): string => {
  // Calculate the previous month's revenue
  const previousRevenue = monthlyRevenue - monthlyRevenueTrend;

  if (previousRevenue === 0) {
    if (monthlyRevenueTrend > 0) {
      return '∞%';
    }

    return '--%';
  }

  const percentageChange = Math.abs(
    (monthlyRevenueTrend / previousRevenue) * 100,
  );

  return `${percentageChange.toFixed(fixed)}%`;
};
